import React, { useState } from 'react';
import './HomeDepositions.css';
import { AiFillStar } from 'react-icons/ai';

const testimonials = [
  {
    name: "Marcelo Willian Silva",
    testimonial: '"Empresa séria de confiança, Consultora Luana está de parabéns, excelente atendimento, estava com muita dificuldade na venda da minha carta, eles resolveram com muita simplicidade e competência, super indico, confiança total, tudo registrado em cartório, novamente Consultora Luana tem meu respeito, fez muito por mim!"'
  },
  {
    name: "Renata Salvador",
    testimonial: '"Recomendo, empresa muito confiável... David Santos me deu todo o suporte que precisei, sempre com educação e transparência... venda do meu consórcio realizado com sucesso. Agradecida."'
  },
  {
    name: "Benedito Melo",
    testimonial: '"Foi a melhor experiência que eu já tive como cliente, foi conduzido por uma colaboradora chamada Hanna Pereira que teve toda cordialidade, paciência e o domínio no processo. Chegando ao êxito e superou todas as minhas expectativas. Parabéns Hanna Pereira."'
  }
];

const getInitials = (name) => {
  const parts = name.trim().split(' ');
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Stars = () => (
  <div className='flex space-x-0.5 mt-2'>
    {[...Array(5)].map((_, i) => (
      <AiFillStar key={i} className='text-yellow-400 text-base' />
    ))}
  </div>
);

const Avatar = ({ name }) => (
  <div
    className='w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0'
    style={{ backgroundColor: '#004e80' }}
  >
    {getInitials(name)}
  </div>
);

function HomeDepositions() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const handleNext = () => setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
  const handlePrev = () => setCurrentTestimonial(prev => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <>
      {/* Desktop */}
      <div className='w-full flex space-x-6 mx-auto my-auto h-sm:hidden' style={{ height: '480px' }}>
        <div className='flex space-x-4 mx-auto my-auto'>
          <div style={{ width: '1000px', height: '480px' }}>
            <div className='text-center'>
              <div>
                <span style={{ color: '#f5be88' }}>Depoimentos</span>
              </div>
              <div className='mt-4'>
                <span className='text-2xl font-extrabold font-raleway'>O quê as pessoas dizem sobre nós</span>
              </div>
            </div>
            <div className='w-full mt-5 mx-auto flex space-x-5 h-96'>
              {testimonials.map((t, i) => (
                <div key={i} className='bg-white h-full w-1/3 rounded-md shadow-3xl flex'>
                  <div className='p-5 px-4 mt-4'>
                    <div className='flex items-center space-x-3'>
                      <Avatar name={t.name} />
                      <span className='text-base font-semibold'>{t.name}</span>
                    </div>
                    <Stars />
                    <div className='mt-3'>
                      <span className='text-base text-justify'>{t.testimonial}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className='w-full flex space-x-6 mx-auto my-auto h-sm:flex hidden px-4' style={{ height: '500px' }}>
        <div className='flex space-x-4 mx-auto my-auto w-full'>
          <div className='w-full h-full'>
            <div className='w-full'>
              <div>
                <span style={{ color: '#f5be88' }}>Depoimentos</span>
              </div>
              <div className='mt-4'>
                <span className='text-xl font-extrabold font-raleway'>O quê as pessoas dizem sobre nós</span>
              </div>
            </div>
            <div className='w-full mt-5 mx-auto flex items-center space-x-2 h-96'>
              <button type="button" onClick={handlePrev} className="cursor-pointer bg-transparent border-none p-0">
                <img src="left.png" alt="anterior" />
              </button>
              <div className='bg-white h-full w-full rounded-md shadow-3xl flex'>
                <div className='p-5 px-4 mt-4'>
                  <div className='flex items-center space-x-3'>
                    <Avatar name={testimonials[currentTestimonial].name} />
                    <span className='text-base font-semibold'>{testimonials[currentTestimonial].name}</span>
                  </div>
                  <Stars />
                  <div className='mt-3'>
                    <span className='text-base text-justify'>{testimonials[currentTestimonial].testimonial}</span>
                  </div>
                </div>
              </div>
              <button type="button" onClick={handleNext} className="cursor-pointer bg-transparent border-none p-0">
                <img src="right.png" alt="próximo" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeDepositions;
